// Container for CASE STUDY collection slides 
// Connect to redux, fetch appropriate slides 

import { connect } from 'react-redux'
import {
  fetchCaseStudyRows
} from './actions'
import {
  getCaseStudyRows,
  getCaseStudyColours,
  getCaseStudyFetching
} from './selectors'
import {
  getScrollEnd
} from '../app/selectors'
import CaseStudies from './case-studies'

const mapStateToProps = state => {
  return {
    rows: getCaseStudyRows(state),
    colours: getCaseStudyColours(state),
    fetching: getCaseStudyFetching(state),
    scrollEnd: getScrollEnd(state)
  }
}

const mapDispatchToProps = dispatch => {
  return {
    onRequestRows: () => {
      dispatch(fetchCaseStudyRows())
    }
  }
}

export default connect(mapStateToProps, mapDispatchToProps)(CaseStudies)



// WEBPACK FOOTER //
// ./src/components/case-studies-container/index.js